import React, { useEffect, useState } from 'react';

import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import OpenInNew from '@mui/icons-material/OpenInNew';
import { useCopyText } from '../../../hooks';
import ItemInfo from './ItemInfo';
import Message from './Message';
import { useIntegrationsStore } from '../state/use-integrations-store';
import Modal from '../../../components/Modal';
import CredentialsInfo from './CredentialsInfo';
import { DEVICE_TYPE } from '../constants';
import ActionButtons from '../ActionButtons';

const RequestModal = () => {
  const { isModalOpen, closeModal, selectedIntegration } = useIntegrationsStore();
  const [message, setMessage] = useState('');
  const isDeferred = selectedIntegration?.status === 'deferred';
  const deviceInfo = selectedIntegration?.device_payload;
  const user_info = deviceInfo?.user_info;
  const address = deviceInfo?.object_info?.address ? `${deviceInfo?.object_info?.address ?? ''}, кв ${deviceInfo?.object_info?.apartment ?? ''}` : '-';
  const serial_number = deviceInfo?.serial_number || 'Отсутствует';
  const meter = deviceInfo?.consumption || 0;
  const companyUrl = selectedIntegration?.company_payload?.url;

  useEffect(() => {
    if (selectedIntegration?.id) {
      setMessage('');
    }
  }, [selectedIntegration?.id]);

  const handleCopy = useCopyText();
  const data = [
    { title: 'Код плательщика', text: selectedIntegration?.payment_code || '-' },
    { title: 'Телефон клиента', text: user_info?.phone || '-' },
    { title: 'Адрес', text: address || '-' },
    { title: 'Email клиента', text: user_info?.email || '-' },
    { title: 'Комментарий от пользователя', text: selectedIntegration?.comment || '-' },
  ];

  return (
    <Modal showModal={isModalOpen} closeCb={closeModal} title={`Заявка от ${user_info?.fio || 'ФИО'}`} showSave={false}>
      <p className="pb-1">{DEVICE_TYPE[deviceInfo?.subtype_id] || 'Тип счетчика не указан'}</p>
      <ItemInfo className={'mb-4'} title={'Серийный номер:'} text={serial_number} handler={() => handleCopy(serial_number, 'Серийный номер скопирован')} />
      <div className={'gap-4 grid grid-cols-2'}>
        {data.map((item) => {
          return <ItemInfo key={item.title} {...item} />;
        })}
      </div>

      <div className={'flex justify-between items-center gap-2 my-4'}>
        <p className={'text-3xl'}>{meter} м³</p>
        <button onClick={() => handleCopy(meter, 'Показания скопированы')}>
          <ContentPasteIcon className={'text-gray-400 hover:text-orange-500'} />
        </button>
      </div>

      <p className={'text-xs'}>Ссылка</p>

      {companyUrl ? (
        <div className="flex justify-between items-center gap-2 pb-4">
          <span className="text-lg text-orange-500 hover:text-orange-600 break-all">{companyUrl}</span>
          <button onClick={() => window.open(companyUrl, '_blank')} className="text-gray-400 hover:text-orange-600">
            <OpenInNew />
          </button>
        </div>
      ) : (
        <p className="pb-4">Отсутствует</p>
      )}

      {isDeferred ? (
        <div className={'bg-gray-100/70 rounded-2xl p-3'}>
          <p className={'text-xs pb-3'}>Push-уведомление клиенту</p>
          <p>{selectedIntegration?.metadata?.message}</p>
        </div>
      ) : (
        <Message message={message} setMessage={setMessage} />
      )}
      <CredentialsInfo integration_id={selectedIntegration?.id} />
      <ActionButtons isDeferred={isDeferred} deviceId={selectedIntegration?.device_id} comment={message} />
    </Modal>
  );
};
export default RequestModal;
